<template>
  <div class="route-search">
    <TitleFrame text="最終ルート確認">
      <template slot="contents">
        出発地：{{search.departure}}<br>
        目的地：{{dropDestionaton.name}}<br>
        出発時刻：{{search.departureTime}}<br>
        <div v-if=lastRoute>到着時刻：{{desTime}} (所要時間：{{lastRoute.routes[0].legs[0].duration_in_traffic.text}}）</div>
        <div class="map-area">
          <GoogleMapOnlyResult/>
        </div>
        <TextLink text="音声案内マップに移動" @click-text="onClickGoGoogle" />
        上のボタンを押すとマップアプリが起動して音声案内を利用できます。
        <TextLink text="事後アンケートに回答" @click-text="onCkickAnswers" />
      </template>
    </TitleFrame>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TitleFrame from '@/components/Templates/TitleFrame'
import RouteSearchInputs from '@/components/Organisms/RouteSearchInputs'
import GoogleMapOnlyResult from '@/components/Organisms/GoogleMapOnlyResult'
import TextLink from '@/components/Atoms/TextLink'
import Firebase from './../../firebase'

export default {
  name: 'route-search',
  components: {
    TitleFrame,
    RouteSearchInputs,
    GoogleMapOnlyResult,
    TextLink
  },
  computed: {
    ...mapState([
      'search',
      'dropDestionaton',
      'lastRoute',
      'isAgreed',
      'isAnswered',
      'DepLatLng',
      'DesLatLng',
      'uid'
    ]),
    desTime () {
      const time = new RegExp('([0-9]{2})', 'g')
      let parsedString = this.search.departureTime.match(time)
      var dt = new Date(2019, 5, 5, parsedString[0], parsedString[1], 40)
      dt.setSeconds(dt.getSeconds() + this.lastRoute.routes[0].legs[0].duration_in_traffic.value)

      let h = this.zeroPaddingAndStr(dt.getHours())
      let m = this.zeroPaddingAndStr(dt.getMinutes())
      return h + ':' + m
    },
    coockieUid () {
      return this.$cookies.get('uid')
    }
  },
  methods: {
    ...mapMutations([
      'changeSearch',
      'loadingStart',
      'loadingEnd',
      'changeCurrentLatLng'
    ]),
    onCkickAnswers (e) {
      this.$router.push({name: 'Answers'})
    },
    zeroPaddingAndStr (num) {
      if (num < 10) {
        return '0' + String(num)
      }
      return String(num)
    },
    onClickGoGoogle () {
      let url = 'https://www.google.com/maps/dir/?api=1&travelmode=driving&origin=' +
        this.search.departure +
        '&origin_place_id=' +
        this.lastRoute.geocoded_waypoints[0].place_id +
        '&destination=' +
        this.dropDestionaton.name +
        '&destination_place_id=' +
        this.lastRoute.geocoded_waypoints[1].place_id

      Firebase.putLog({
        ActionType: 'RunMapApp',
        url: url
      })
      window.open(url, '_blank')
    }
  },
  mounted () {
    this.loadingStart()
    if (!this.coockieUid || !this.uid) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.isAgreed) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.isAnswered) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.DepLatLng && !this.DesLatLng) {
      this.$router.push({name: 'RouteSearch'})
    }
    if (!this.dropDestionaton) {
      this.$router.push({name: 'DropSpotSelect'})
    }
    this.loadingEnd()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
.route-search{
  height: 100%;
}
.map-area{
  height: calc(100% - 16rem);
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/RouteResult.vue